/**
=========================================================
* CarbonAGX Website - v2.0.0
=========================================================

* Copyright 2022 CarbonAGX

 =========================================================

*/


import Calculator from "pages/Calculator";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import logoImage from "assets/images/carbonagxcalculator.png";

export default function App() {

 return (
    <Box>
        <Calculator />
    </Box>
 );
}
